import React, { useEffect } from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import EChallanCommonReasonsV2 from "../e-challan-common-reasons-v2";
import EChallanBreadCrumb from "../../shared/e-challan-breadcrumb";
import EChallanTestimonials from "../e-challan-testimonials";
import EChallanHeroBannerV2 from "../e-challan-hero-banner-v2";
import WhyPayChallans from "../e-challan-why-pay-challans";
import EChallanTrustFactors from "../e-challan-trust-factors";
import EChallanEasySteps from "../e-challan-easy-steps";
import EChallanFaqsVariant from "../e-challan-faq-variant";
import isObjectEmpty from "../../../utils/helpers/isObjectEmpty";
import EChallanRecentTransaction from "../e-challan-recent-transaction";
import parseLocationSearchParams from "../../../utils/helpers/parse-location-search-params";
import { mobileNumberValidator } from "../../../utils/validators/mobile-number-validator";
import { isValidRegistrationNo } from "../../../utils/helpers/is-valid-registration-no";

const EChallanPartner = ({
    history,
    mobile,
    cmsContent = null,
    isSSR = false,
    fetchChallanLandingPageDataConnect = () => {},
    regNumberList,
    recentTransaction,
    isLoggedIn,
    secureToken,
    fetchRegNumberListConnect,
    fetchOrderDataConnect,
    logoutConnect,
    markUnauthorizedConnect,
    setRegNoConnect,
    setMobileConnect
}) => {
    const checkForValidRegistrationNumber = (regNo) => {
        return isValidRegistrationNo(regNo.replace(/\s/g, ""));
    };

    const preFillDetails = ({vrn, phone}) => {
        if (phone && mobileNumberValidator(phone)) setMobileConnect(phone);
        if (vrn) {
            setRegNoConnect(vrn);
            history.push("/my-challans/");
        }
    };

    useEffect(() => {
        if (isLoggedIn) {
            if (!isSSR) {
                fetchRegNumberListConnect(secureToken);
            }
            if (!recentTransaction || !isSSR) {
                fetchOrderDataConnect(secureToken);
            }
        }
        /* eslint-disable react-hooks/exhaustive-deps */
    }, [isLoggedIn]);

    const {
        heroBannerData = {},
        whyPayChallanData = {},
        whatIsChallanData = {},
        whyChallanIssueData = {},
        challanTestimonialsData = {},
        challanFaqData = {},
        howToPayChallanData = {},
        trustChallanData = {}
    } = cmsContent || {};

    useEffect(() => {
        if (!isSSR && !isObjectEmpty(cmsContent)) {
            fetchChallanLandingPageDataConnect();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSSR]);

    useEffect(() => {
        const queryParams = parseLocationSearchParams(history.location.search);
        const { enc_vrn: encodedVrn = "", phone = "" } = queryParams;
        const vrn = encodedVrn ? window.atob(decodeURIComponent(encodedVrn)) : null;
        if (vrn) {
            const isValidMobileNumber = mobileNumberValidator(phone);
            const isValidVrn = checkForValidRegistrationNumber(vrn);
            if (isValidVrn || isValidMobileNumber) {
                if (mobile && phone && Number(mobile) !== Number(phone)) {
                    logoutConnect().then(() => {
                        markUnauthorizedConnect();
                        preFillDetails({...queryParams, vrn});
                    });
                } else {
                    preFillDetails({...queryParams, vrn});
                }
            }
        }
        /* eslint-disable react-hooks/exhaustive-deps */
    }, []);

    return (
        <React.Fragment>
            <EChallanHeroBannerV2 heroBannerData={heroBannerData} regNumberList={regNumberList} />
            {!!recentTransaction && <EChallanRecentTransaction orderData={recentTransaction} />}
            <EChallanEasySteps howToPayChallanData={howToPayChallanData} />
            <EChallanTrustFactors trustChallanData={trustChallanData} />
            <WhyPayChallans whyPayChallanData={whyPayChallanData} />
            <EChallanCommonReasonsV2 whatIsChallanData={whatIsChallanData} whyChallanIssueData={whyChallanIssueData} />
            <EChallanTestimonials challanTestimonialsData={challanTestimonialsData} />
            <EChallanFaqsVariant challanFaqData={challanFaqData} />
            <EChallanBreadCrumb />

        </React.Fragment>
    );
};

EChallanPartner.propTypes = {
    history: PropTypes.object,
    mobile: PropTypes.string,
    cmsContent: PropTypes.object,
    isSSR: PropTypes.bool,
    fetchChallanLandingPageDataConnect: PropTypes.func,
    regNumberList: PropTypes.array,
    recentTransaction: PropTypes.object,
    isLoggedIn: PropTypes.bool,
    secureToken: PropTypes.string,
    fetchRegNumberListConnect: PropTypes.func,
    fetchOrderDataConnect: PropTypes.func,
    logoutConnect: PropTypes.func,
    markUnauthorizedConnect: PropTypes.func,
    setRegNoConnect: PropTypes.func,
    setMobileConnect: PropTypes.func
};

export default EChallanPartner;
